<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
      <ToastViewer />
    </NuxtLayout>
  </div>
</template>

<script lang="ts">
import { useLanguageStore } from "~/stores/language";

import ToastViewer from "./components/ToastViewer/ToastViewer.vue";

export default {
  name: "App",

  components: {
    ToastViewer,
  },

  setup() {
    const languageStore = useLanguageStore();

    useHead({
      /**
       * This is a template for the title of the page.
       *
       * It uses the application name and the specific page title that is
       * provided by the page component. The page title is provided by the
       * `title` property in the `useHead` composable.
       */
      titleTemplate: (pageTitle) => {
        const appName = languageStore.t("app_name");
        return pageTitle ? `${pageTitle} | ${appName}` : appName;
      },
    });
  },
};
</script>
